import produce from 'immer';
import {
  FAILURE,
  fulfilled,
  idle,
  pending,
  rejected,
  REQUEST,
  SUCCESS,
} from 'src/redux/constants';
import { TAKING_SURVEY } from './constants';
import {
  TakingSurveyActionTypes,
  ITakingSurveySuccess,
  ITakingSurveyError,
  ITakingSurveyState,
} from './types';

const initialState: ITakingSurveyState = {
  status: idle,
  entities: {},
  error: null,
};

export default produce(
  (
    draft = initialState,
    action: TakingSurveyActionTypes,
  ): ITakingSurveyState => {
    switch (action.type) {
      case TAKING_SURVEY + REQUEST: {
        draft.status = pending;
        draft.error = null;
        break;
      }
      case TAKING_SURVEY + SUCCESS: {
        draft.status = fulfilled;
        draft.entities = (action as ITakingSurveySuccess).payload;
        break;
      }
      case TAKING_SURVEY + FAILURE: {
        draft.status = rejected;
        draft.error = (action as ITakingSurveyError).error;
        break;
      }
      default:
        return draft;
    }
  },
);
